import { ResourceBreadcrumbTitle } from "@/components/resource-header/ResourceBreadcrumbTitle"

import {
  TEST_SET_NAME_MAX_LENGTH,
  useTestSetBreadcrumb,
} from "./useTestSetBreadcrumb"

const formatBreadcrumb = (text: string) => {
  return text
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

interface TestSetBreadcrumbContentProps {
  segment: string
  isLast: boolean
}

export const TestSetBreadcrumbContent = ({
  segment,
  isLast,
}: TestSetBreadcrumbContentProps) => {
  const { currentDisplayName } = useTestSetBreadcrumb(segment)

  const displayName = currentDisplayName

  return (
    <span className={isLast ? "font-semibold" : ""}>
      {displayName || formatBreadcrumb(segment)}
    </span>
  )
}

interface TestSetBreadcrumbTitleProps {
  segment: string
}

/** The current test set's name as the last breadcrumb, renamed in place and saved on Enter or blur. */
export const TestSetBreadcrumbTitle = ({
  segment,
}: TestSetBreadcrumbTitleProps) => {
  const {
    currentDisplayName,
    isPersisted,
    metadataIsLoading,
    renameTestSet,
    validateTestSetName,
  } = useTestSetBreadcrumb(segment)

  return (
    <ResourceBreadcrumbTitle
      data-testid="test-set-name-title"
      label="Test set name"
      placeholder={formatBreadcrumb(segment)}
      value={currentDisplayName ?? ""}
      maxLength={TEST_SET_NAME_MAX_LENGTH}
      validate={validateTestSetName}
      // Waits for the saved name so the field does not open blank. If that load fails, rename still works from an empty field.
      disabled={!isPersisted || metadataIsLoading}
      onSave={renameTestSet}
    />
  )
}
